<template>
  <v-modal :name="name" :title="confirmMessage || $t('frontend_sure')">
    <div class="flex flex-col items-center justify-center">
      <p v-if="messageContent" class="px-8 text-sm pt-4 text-black">{{ messageContent }}</p>
      <gd-toggle v-if="checkboxText" v-model="checkboxOption" class="px-8 pt-4" toggleTextClasses=" px-2 leading-none text-sm text-black" :toggleText="checkboxText" />
      <div class="flex flex-row w-full justify-center py-8">
        <gd-button variant="shadow" :size="buttonSize" @click="close();" class="mr-2">{{
            cancelText || $t('frontend_cancel') 
          }}
        </gd-button>
        <gd-button variant="shadowPrimary" :size="buttonSize" @click="confirm();" class="ml-2" primary>{{
            buttonText || $t('frontend_confirm')
          }}
        </gd-button>
      </div>
    </div>
  </v-modal>
</template>
<script>

import VModal from './Modal';
import GdButton from './Button';
import GdToggle from './Toggle'

export default {
  name: 'ConfirmModal',
  data(){
    return {
      checkboxOption: false
    }
  },
  components: {
    VModal,
    GdButton,
    GdToggle
  },
  props: {
    name: {
      required: true
    },
    callback: {
      required: false
    },
    cancelText: {
      default: ''
    },
    buttonText: {
      default: ''
    },
    buttonSize:{
      required: false,
      default: " "
    },
    confirmMessage: {
      required: false
    },
    messageContent: {
      required: false
    },
    checkboxText: {
      required: false
    }
  },
  methods: {
    close() {
      this.$root.$emit('modal-close', this.name);
      if(this.checkboxText){
        
      } else this.$emit('close');
    },
    open() {
      this.$root.$emit('modal-open', this.name);
    },
    confirm() {
      this.$root.$emit('modal-close', this.name);
      if (this.callback) {
        return this.callback();
      }
      if(this.checkboxText){
        if(this.checkboxOption) this.$emit('confirmWithToggleOn');
        else this.$emit('confirmWithToggleOff');
      } else {
        this.$emit('confirm');
      }
    }
  }
};
</script>
